// Permission menu per user (selaras dengan backend/menu_access.py).
// user.menu_permissions: null = akses penuh; array = key menu yang diizinkan.

export function canSee(user, key) {
  if (!user) return false;
  if (user.role === "super_admin") return false;
  const perms = user.menu_permissions;
  if (perms == null) return true;
  return perms.includes(key);
}

export function canSeeAny(user, keys) {
  return keys.some((k) => canSee(user, k));
}

// Urutan halaman pembuka bila Dashboard tidak diizinkan
const LANDING = [
  ["dashboard", "/dashboard"],
  ["pemasukan", "/pemasukan"],
  ["pengeluaran", "/pengeluaran"],
  ["produksi", "/produksi"],
  ["produksi_kayu", "/produksi/kayu"],
  ["produksi_bakar", "/produksi/bakar"],
  ["produksi_pembelian", "/produksi/pembelian"],
  ["produksi_bahan", "/produksi/bahan"],
  ["produksi_briket", "/produksi/briket"],
  ["produksi_transfer", "/produksi/transfer"],
  ["piutang", "/piutang"],
  ["hutang_piutang", "/hutang-piutang"],
  ["akun", "/pribadi/akun"],
  ["transfer", "/pribadi/transfer"],
  ["impor_mutasi", "/pribadi/impor-mutasi"],
  ["pph_op", "/pribadi/pajak"],
  ["kredit_pajak", "/pribadi/kredit-pajak"],
  ["harta", "/pribadi/harta"],
  ["utang", "/pribadi/utang"],
  ["tanggungan", "/pribadi/tanggungan"],
  ["laporan_semua", "/laporan/semua"],
  ["laba_rugi", "/laporan/laba-rugi"],
  ["neraca", "/laporan/neraca"],
  ["arus_kas", "/laporan/arus-kas"],
  ["dividen", "/laporan/dividen"],
  ["pph_05", "/laporan/pph-05"],
  ["pph_normal", "/laporan/pph-normal"],
  ["riwayat_bayar", "/pajak/riwayat-bayar"],
  ["kategori_pemasukan", "/pemasukan/kategori"],
  ["kategori_pengeluaran", "/pengeluaran/kategori"],
  ["pembeli", "/pemasukan/pembeli"],
];

export function firstAllowedPath(user) {
  const hit = LANDING.find(([k]) => canSee(user, k));
  return hit ? hit[1] : "/pengaturan/profil";
}
